import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import API from '../services/api';

function Organization() {
  const [orgData, setOrgData] = useState({
    name: '',
    email: '',
    phone: '',
    // ✅ NEW: Billing address fields
    address: '',
    city: '',
    state: '',
    pincode: '',
    country: 'India'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrganization();
  }, []);

  const loadOrganization = async () => {
    setLoading(true);
    try {
      const response = await API.get('/organization');
      // ✅ Merge with defaults so new fields don't break if backend returns null
      setOrgData({
        name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        country: 'India',
        ...response.data.data
      });
    } catch (error) {
      console.error('Error loading organization:', error);
    }
    setLoading(false);
  };

  const handleOrgUpdate = async (e) => {
    e.preventDefault();
    const toastId = toast.loading('Updating organization...');
    try {
      await API.put('/organization', orgData);
      toast.success('Organization updated successfully!', { id: toastId });
    } catch (error) {
      toast.error('Failed to update organization', { id: toastId });
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner">⏳</div>
          <p className="loading-text">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="org-page">
      <div className="org-page-wrapper">

        {/* Header */}
        <div className="page-header">
          <h1 className="page-title">🏢 Organization</h1>
          <p className="page-subtitle">Manage your organization details</p>
        </div>

        {/* Form Card */}
        <div className="org-form-card">
          <div className="org-form-card-header">
            <h2 className="org-form-card-title">Organization Details</h2>
            <p className="org-form-card-subtitle">Update your organization name and contact info</p>
          </div>

          <form onSubmit={handleOrgUpdate} className="org-form-body">

            {/* ── Section 1: Basic Info ── */}
            <div className="org-form-section">
              <div className="org-form-section-header">
                <span className="org-form-section-number">1</span>
                <h3 className="org-form-section-title">Basic Information</h3>
              </div>

              <div className="settings-form-group">
                <label className="settings-form-label">
                  Organization Name <span className="settings-form-required">*</span>
                </label>
                <input
                  type="text"
                  value={orgData.name}
                  onChange={(e) => setOrgData({ ...orgData, name: e.target.value })}
                  className="settings-form-input"
                  placeholder="Your Organization Name"
                  required
                />
              </div>

              <div className="settings-form-group">
                <label className="settings-form-label">
                  Email Address <span className="settings-form-required">*</span>
                </label>
                <input
                  type="email"
                  value={orgData.email}
                  onChange={(e) => setOrgData({ ...orgData, email: e.target.value })}
                  className="settings-form-input"
                  placeholder="org@example.com"
                  required
                />
              </div>

              <div className="settings-form-group">
                <label className="settings-form-label">Phone Number</label>
                <input
                  type="text"
                  value={orgData.phone || ''}
                  onChange={(e) => setOrgData({ ...orgData, phone: e.target.value })}
                  className="settings-form-input"
                  placeholder="+91 9876543210"
                />
              </div>
            </div>

            {/* ── Section 2: Billing Address (NEW) ── */}
            <div className="org-form-section">
              <div className="org-form-section-header">
                <span className="org-form-section-number">2</span>
                <h3 className="org-form-section-title">Billing Address</h3>
              </div>

              <div className="settings-form-group">
                <label className="settings-form-label">Street Address</label>
                <input
                  type="text"
                  value={orgData.address || ''}
                  onChange={(e) => setOrgData({ ...orgData, address: e.target.value })}
                  className="settings-form-input"
                  placeholder="123, MG Road, Sector 5"
                />
              </div>

              <div className="org-form-row">
                <div className="settings-form-group">
                  <label className="settings-form-label">City</label>
                  <input
                    type="text"
                    value={orgData.city || ''}
                    onChange={(e) => setOrgData({ ...orgData, city: e.target.value })}
                    className="settings-form-input"
                    placeholder="Delhi"
                  />
                </div>

                <div className="settings-form-group">
                  <label className="settings-form-label">State</label>
                  <input
                    type="text"
                    value={orgData.state || ''}
                    onChange={(e) => setOrgData({ ...orgData, state: e.target.value })}
                    className="settings-form-input"
                    placeholder="Delhi"
                  />
                </div>
              </div>

              <div className="org-form-row">
                <div className="settings-form-group">
                  <label className="settings-form-label">PIN Code</label>
                  <input
                    type="text"
                    value={orgData.pincode || ''}
                    onChange={(e) => setOrgData({ ...orgData, pincode: e.target.value })}
                    className="settings-form-input"
                    placeholder="110001"
                    maxLength={6}
                  />
                </div>

                <div className="settings-form-group">
                  <label className="settings-form-label">Country</label>
                  <select
                    value={orgData.country || 'India'}
                    onChange={(e) => setOrgData({ ...orgData, country: e.target.value })}
                    className="settings-form-input"
                  >
                    <option value="India">🇮🇳 India</option>
                    <option value="USA">🇺🇸 USA</option>
                    <option value="UK">🇬🇧 UK</option>
                    <option value="UAE">🇦🇪 UAE</option>
                    <option value="Canada">🇨🇦 Canada</option>
                    <option value="Australia">🇦🇺 Australia</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="settings-actions">
              <button type="submit" className="settings-btn-save">
                💾 Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Organization;